<div fxLayout fxFlexFill class="parent_container">
  <div fxFlex fxLayout fxLayoutGap="120px" fxLayoutAlign="center center">
    <div fxFlex="400px" fxFlex.lt-md="80">
      <ng-container *ngIf="!loading && !error">
        <h2>
          <img class="inviter-img" [src]="inviteDetails.inviter.picture" />
          <span>
            {{ inviteDetails.inviter.name }} is using {{ 'CORE.PRODUCT_NAME' | transloco }} to connect with Airbnb.
          </span>
        </h2>
        <p>
          {{ inviteDetails.inviter.name }} has invited you to connect your Airbnb account to their
          {{ 'CORE.PRODUCT_NAME' | transloco }} account, to help them manage it. Click the button below to get started.
        </p>

        <div fxLayout fxLayoutGap="16px">
          <img src="/assets/images/trustpilot.svg" />
          <span class="text__small">{{ 'CORE.PRODUCT_NAME' | transloco }} has a 4.8 score</span>
        </div>

        <button class="fw connect-button bg-airbnb" mat-flat-button (click)="connectAirbnb()">
          <div fxLayout fxLayoutAlign="start center">
            <ui-icon-airbnb class="absolute-icon" [white]="true"></ui-icon-airbnb>
            <span fxFlex>Connect with Airbnb</span>
          </div>
        </button>
      </ng-container>

      <ng-container *ngIf="loading">
        <mat-spinner [diameter]="32"></mat-spinner>
        <p>Checking a few things...</p>
      </ng-container>

      <ng-container *ngIf="error">
        <p>We're having some trouble validating your invite. Please reach out to support if this keeps happening</p>
      </ng-container>
    </div>
    <div fxHide.lt-md fxFlex>
      <img src="/assets/images/login/login.svg" />
    </div>
  </div>
</div>
